import axios from '@/http/axios'
import store from '../../store/store'
import {createCancelTokenHandler, makeQuery} from '../axios/utils'

const cancelTokenHandlerObject = {
  getProfileReceivedEvents: createCancelTokenHandler('getProfileReceivedEvents'),
  getProfileReceivedEventsNavbar: createCancelTokenHandler('getProfileReceivedEventsNavbar'),
  getProfileSentEvents: createCancelTokenHandler('getProfileSentEvents'),
  getProfileTickets: createCancelTokenHandler('getProfileTickets'),
  getProfileTasks: createCancelTokenHandler('getProfileTasks')
}

/* Profile */
export function getProfile () {
  return axios({
    url: 'v1/profile',
    method: 'get'
  })
}

export function editProfile (payment) {
  return axios.patch('v1/profile', payment)
}

export function getProfileReceivedEvents (page, filters = {}, sorts = [], navbar = false) {
  let queries = makeQuery(page, filters, sorts)

  if (queries.length > 0) queries = `?${  queries.join('&')}`

  return axios({
    url: `v1/profile/received-events${queries}`,
    method: 'get',
    // setting a cancel token and canceling the previous request of this type
    cancelToken: cancelTokenHandlerObject[`getProfileReceivedEvents${navbar ? 'Navbar' : ''}`].handleRequestCancellation().token
  })
}

export function getProfileSentEvents (page, filters = {}, sorts = []) {
  let queries = makeQuery(page, filters, sorts)

  if (queries.length > 0) queries = `?${  queries.join('&')}`

  return axios({
    url: `v1/profile/sent-events${queries}`,
    method: 'get',
    // setting a cancel token and canceling the previous request of this type
    cancelToken: cancelTokenHandlerObject['getProfileSentEvents'].handleRequestCancellation().token
  })
}

export function editProfileBrowserSettings (payload = {}) {
  const setting = {
    ...payload,
    tables: store.state.table.tables,
    // tables: {},
    // tables: store.state.table.tables.storesListTable ? store.state.table.tables.storesListTable : [],
    theme: store.state.theme
  }
  delete setting.tables.tables
  delete setting.tables.theme
  store.dispatch('auth/updateUserInfo', {browser_setting: JSON.stringify(setting) })
  // console.log(JSON.stringify(setting))
  // console.log(setting)
  return axios.patch('v1/profile/browser-settings?loading=false', { settings: JSON.stringify(setting) })
}

export function getProfileActiveSessions () {
  return axios({
    url: 'v1/profile/active-sessions',
    method: 'get'
  })
}

export function revokeActiveSession (id) {
  return axios({
    url: `v1/profile/active-sessions/${id}`,
    method: 'delete'
  })
}

export function getProfileTickets (page, filters = {}, sorts = []) {
  let queries = makeQuery(page, filters, sorts)

  if (queries.length > 0) queries = `?${queries.join('&')}`

  return axios({
    url: `v1/profile/tickets${queries}`,
    method: 'get',
    // setting a cancel token and canceling the previous request of this type
    cancelToken: cancelTokenHandlerObject['getProfileTickets'].handleRequestCancellation().token
  })
}

export function getProfileTasks (page, filters = {}, sorts = []) {
  let queries = makeQuery(page, filters, sorts)

  if (queries.length > 0) queries = `?${queries.join('&')}`

  return axios({
    url: `v1/profile/tasks${queries}`,
    method: 'get',
    // setting a cancel token and canceling the previous request of this type
    cancelToken: cancelTokenHandlerObject['getProfileTasks'].handleRequestCancellation().token
  })
}
